// cameraSlice.js (updated)
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from "axios";
import { showLoadingScreen, setSnackBar } from "../../reusable_components/site_data/siteDataSlice";
import { backend_url } from "../../App";

// Create async thunk for better error handling
export const getCameras = createAsyncThunk(
  'cameras/getCameras',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      dispatch(showLoadingScreen(true));
      const Header = {
        'Authorization': `Token ${localStorage.getItem("token")}`
      };

      let allCameras = [];
      let nextUrl = `${backend_url}/core/api/camera/`;

      while (nextUrl) {
        const config = {
          headers: Header,
        };

        const response = await axios.get(nextUrl, config);
        allCameras = [...allCameras, ...response.data.results];
        nextUrl = response.data.next;
      }

      return {
        count: allCameras.length,
        next: null,
        previous: null,
        results: allCameras
      };

    } catch (error) {
      // Handle error properly
      const errorMessage = error.response?.data?.non_field_errors?.[0] 
        || error.response?.data?.detail 
        || error.message 
        || 'Failed to fetch cameras';
      
      dispatch(setSnackBar(errorMessage));
      return rejectWithValue(errorMessage);
    } finally {
      dispatch(showLoadingScreen(false));
    }
  }
);

export const cameraSlice = createSlice({
  name: 'cameras',
  initialState: {
    cameras: {
      count: 0,
      next: null,
      previous: null,
      results: []
    },
    loading: false,
    error: null,
  },
  reducers: {
    setCameras: (state, action) => {
      state.cameras = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCameras.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCameras.fulfilled, (state, action) => {
        state.loading = false;
        state.cameras = action.payload;
      })
      .addCase(getCameras.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Action creators are generated for each case reducer function
export const { setCameras, clearError } = cameraSlice.actions;
export const selectCameras = (state) => state.cameras.cameras;
export const selectCamerasLoading = (state) => state.cameras.loading;
export const selectCamerasError = (state) => state.cameras.error;

export default cameraSlice.reducer;